import { Component, Input, OnDestroy } from '@angular/core';
import { PersonGbVersionDetailEntryMeta } from '../../../../../core/gb-api';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { ErwerberVeraeussererDetailEntryMeta } from '../../../../../core/gb-api/model/erwerberVeraeussererDetailEntryMeta';
import { HandelsangabenDetailEntryMeta } from '../../../../../core/gb-api/model/handelsangabenDetailEntryMeta';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { KompaktPersongbComponent } from '../../../../../shared/kompaktdarstellung/persongb/kompakt-persongb.component';
import { KopfdatenelementComponent } from '../../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { ReadMoreComponent } from '../../../../../shared/widgets/read-more/read-more.component';
import { BetragPipe } from '../../../../../shared/pipes/simple/betrag.pipe';
import { DecimalHochkommaPipe } from '../../../../../shared/pipes/simple/decimalHochkomma.pipe';
import { KompaktGrundstueckPipe } from '../../../../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.pipe';
import { PersonStammMasterDetailEntryMeta } from '../../../../../core/personstamm-api';

@Component({
  selector: 'cap-handelsangaben-detail',
  templateUrl: './handelsangaben-detail.component.html',
  styleUrls: ['./handelsangaben-detail.component.scss'],
  imports: [
    KompaktPersongbComponent,
    KopfdatenelementComponent,
    ReadMoreComponent,
    TranslatePipe,
    BetragPipe,
    DecimalHochkommaPipe,
    KompaktGrundstueckPipe
  ]
})
export class HandelsangabenDetailComponent implements OnDestroy {
  @Input()
  handelsangaben: HandelsangabenDetailEntryMeta;

  @Input()
  erwerberVeraeusserer: ErwerberVeraeussererDetailEntryMeta;

  @Input()
  gbPerson: PersonGbVersionDetailEntryMeta;
  @Input()
  auskunftsperre?: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum;
  public language: string;
  private subscription: Subscription;

  constructor(
    public activeModal: NgbActiveModal,
    private translateService: TranslateService
  ) {
    keysToTranslate<string>(['handelsangabenZu', 'Preis', 'Wertquote']);
    keysToTranslate<ErwerberVeraeussererDetailEntryMeta.BeteiligungEnum>(['VERAEUSSERER', 'ERWERBER']);

    this.subscription = this.translateService.onLangChange.subscribe((language) => {
      this.language = language.lang;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
